import { render, staticRenderFns } from "./shop-management-search.vue?vue&type=template&id=3274af27&scoped=true"
import script from "./shop-management-search.vue?vue&type=script&lang=js"
export * from "./shop-management-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3274af27",
  null
  
)

export default component.exports